// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type CashierCurrency =
  | 'ADA'
  | 'AUD'
  | 'BNB'
  | 'BRL'
  | 'BTC'
  | 'BUSD'
  | 'CAD'
  | 'CNY'
  | 'DAI'
  | 'DOGE'
  | 'DOT'
  | 'ETH'
  | 'EUR'
  | 'GBP'
  | 'INR'
  | 'JPY'
  | 'KRW'
  | 'LTC'
  | 'MATIC'
  | 'MXN'
  | 'NZD'
  | 'SHIB'
  | 'SOC'
  | 'SOL'
  | 'THB'
  | 'TON'
  | 'TRX'
  | 'TRY'
  | 'USD'
  | 'USDC'
  | 'USDT'
  | 'VND'
  | 'XMR'
  | 'XRP';

export type CashierCurrencyType =
  | 'banking'
  | 'crypto';

export type CashierFindCurrencyConfigInput = {
  name?: CashierCurrency | null | undefined;
  site: CashierSite;
  type?: CashierCurrencyType | null | undefined;
};

export type CashierSite =
  | 'bitcasino'
  | 'empire'
  | 'livecasino'
  | 'saibo'
  | 'sportsbet'
  | 'sportsbetmx';

export type CurrencyDropdownQueryVariables = Exact<{
  input: Types.CashierFindCurrencyConfigInput;
}>;


export type CurrencyDropdownQuery = { features: { id: string, walletCurrency: string | undefined, isUbtcEnabled: boolean | undefined } | undefined, banking: { myAllBalances: { edges: Array<{ node: { id: string, currency: string | undefined, cashierBalance: number | undefined, realBalance: number | undefined, vaultBalance: number | undefined } | undefined } | undefined> | undefined } | undefined } | undefined, cashier: { currencyConfig: { edges: Array<{ node: { id: string, imageUrl: string | undefined, name: Types.CashierCurrency | undefined, isEnabledFlag: string | undefined, type: Types.CashierCurrencyType | undefined, maximumFractionDigits: number | undefined } | undefined } | undefined> | undefined } | undefined } | undefined };


export const CurrencyDropdownQueryDocument = gql`
    query CurrencyDropdownQuery($input: CashierFindCurrencyConfigInput!) {
  features {
    id
    walletCurrency: myGroupTag(name: "DepositCurrency")
    isUbtcEnabled: hasTag(name: "uBTC")
  }
  banking {
    myAllBalances(conversionCurrency: "USD") {
      edges {
        node {
          id
          currency
          cashierBalance
          realBalance
          vaultBalance
        }
      }
    }
  }
  cashier {
    currencyConfig(input: $input) {
      edges {
        node {
          id
          imageUrl
          name
          isEnabledFlag
          type
          maximumFractionDigits
        }
      }
    }
  }
}
    `;